import React from 'react';

import { MediaQueriesContext } from './MediaQueriesContext';

const useMedia = () => React.useContext(MediaQueriesContext);

export default useMedia;
